var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 903 445",
    width: 903,
    height: 445,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logotype Original &amp; Monochromatic-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #1799b2 } \n\t\t.s1 { fill: #3a4651 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Artboards_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m650.1 0h-59.9c0 56.5 22.9 107.6 59.9 144.6v-144.5q0 0 0-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m650.1 144.6c37 37 88.1 59.9 144.6 59.9v-59.9q0 0 0 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m590 144.6h60.1v59.9l-60-59.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m228.9 257.8h37.3v133.2h-37.3v-25.5h-2.7c-5.3 17.3-21.8 29-44.2 29-36.5 0-61.9-31.4-61.9-70.3 0-38.4 24.8-69.9 61.3-69.9 22.4 0 39.5 11.8 44.8 29.1h2.7zm-35.7 103.6c19.7 0 35.7-16.5 35.7-37 0-20.5-16-37-35.7-37-19.8 0-35.7 16.5-35.7 37 0 20.5 15.9 37 35.7 37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m316.4 348.1c2.6 12.6 13.3 17.1 30.9 17.1 19.7 0 25.6-5.6 25.6-11.5 0-5-4.6-9.3-19.8-12.8l-31.7-7.2c-22.9-5-39.7-13.5-39.7-37.8 0-23.2 24.8-42.1 58.7-42.1 41.8 0 61.8 22.6 64.4 46.6h-37.3c-2.6-11.2-11.2-16.8-25.8-16.8-13.3 0-22.7 4.8-22.7 12 0 7 9.1 9.6 24.8 13.1l24.8 5.6c22.9 5.1 41.3 11.4 41.6 38.9 0.2 21.9-24.5 41.8-62.7 41.8-42.6 0-65.8-20.2-68.4-46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m442.9 236.4v-18.6h38.7v19.7c0 13.9-0.3 26.7-22.7 26.7v2.6h59.2v33.3h-37.9v44c0 13.4 0 15 13.4 15h21.8v31.9h-34.3c-27.2 0-38.2-10.6-38.2-37.3v-53.6h-29.8v-33.3c30.9 0 29.8-10.6 29.8-30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m534.1 204.5h18.6 18.7v186.5h-37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m698.8 257.8h37.3v133.2h-37.3v-25.5h-2.7c-5.3 17.3-21.9 29-44.2 29-36.6 0-61.9-31.4-61.9-70.3 0-38.4 24.8-69.9 61.3-69.9 22.4 0 39.5 11.8 44.8 29.1h2.7zm-35.8 103.6c19.8 0 35.8-16.5 35.8-37 0-20.5-16-37-35.8-37-19.7 0-35.7 16.5-35.7 37 0 20.5 16 37 35.7 37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m790.7 444.3h-37.3v-186.5h37.3v25.6h2.6c5.6-15.7 19.5-29.1 43.8-29.1 37.3 0 62.6 31.5 62.6 70.4 0 38.4-24.8 69.8-62.1 69.8-24.3 0-38.9-13.3-44.3-29h-2.6zm36-157c-20 0-36 16.5-36 37 0 20.6 16 37.1 36 37.1 19.9 0 35.7-16.5 35.7-37.1 0-20.5-15.8-37-35.7-37z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m105.8 355.1h-65.5v-150.6h-20-20v145.5 41h41.1 86c-9.7-9.6-17.1-21.8-21.6-35.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.25d232cda8ee4a957c126728e3972de1.svg";
export { ForwardRef as ReactComponent };